import {
  FlexColumn,
  FormControls,
  TextFieldReadOnly,
} from '@elementary/common-ui/components';
import {
  OwnersChipList,
  TagsChipList,
} from '@elementary/common-ui/components/ChipList';
import { Typography } from '@mui/material';
import SeverityRenderer from 'shared/components/SeverityRenderer';
import { Severity } from 'shared/types';

type Props = {
  description?: string;
  tags?: string[];
  owners?: string[];
  severity: Severity;
  errorIf?: string;
  warnIf?: string;
};

const TestMetadataFields = ({
  description,
  tags,
  owners,
  severity,
  errorIf,
  warnIf,
}: Props) => {
  const isBaseFieldsEmpty = !description && !owners?.length && !tags?.length;

  return (
    <>
      {!isBaseFieldsEmpty && (
        <FormControls.FieldsWrapper>
          <FormControls.FormTitle>Test Metadata</FormControls.FormTitle>

          {description && (
            <FlexColumn sx={{ gap: 1 }}>
              <FormControls.FormText>Description:</FormControls.FormText>
              <TextFieldReadOnly value={description} />
              <Typography
                sx={{
                  fontSize: '12px',
                  color: 'common.gray11',
                  visibility: description ? 'visible' : 'hidden',
                }}
              >
                {`${description?.length} Characters`}
              </Typography>
            </FlexColumn>
          )}

          {!!owners?.length && (
            <FormControls.Row>
              <FormControls.FormText>Owners:</FormControls.FormText>
              <OwnersChipList value={owners} buttonText="Add owner" readOnly />
            </FormControls.Row>
          )}

          {!!tags?.length && (
            <FormControls.Row>
              <FormControls.FormText>Tags:</FormControls.FormText>
              <TagsChipList value={tags} buttonText="Add tag" readOnly />
            </FormControls.Row>
          )}
        </FormControls.FieldsWrapper>
      )}

      <FormControls.Divider />
      <FormControls.FieldsWrapper>
        <FormControls.FormTitle>Advanced Settings</FormControls.FormTitle>
        <SeverityRenderer
          severity={severity}
          warnIf={warnIf}
          errorIf={errorIf}
        />
      </FormControls.FieldsWrapper>
    </>
  );
};

export default TestMetadataFields;
